/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */

import { TweenLite, Power1 } from 'gsap/TweenMax';
import 'EasePack';
import getElementsArray from '@/scripts/utils/get-elements-array';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import loadFonts from '@/scripts/utils/load-fonts';
import initHeaderNav from '@/scripts/elements/header-nav';
import '@/scripts/blocks/two-halves-slider';
import '@/scripts/elements/cover';
import '@/scripts/elements/cookies';
import '@/scripts/elements/preloader';
import '@/scripts/scrollmagic';
import '@/fonts';
import '@/styles/main.scss';
import initSliders from '@/scripts/blocks/sliders';
import initInput from '@/scripts/blocks/form-input';
import initGridWithFilters from '@/scripts/blocks/filters';
import initCover from '@/scripts/blocks/cover-slider';

loadFonts(['Prata:400:latin', 'Cormorant:300,400,500,700:latin']);

TweenLite.defaultEase = Power1.easeOut;
document.addEventListener('DOMContentLoaded', () => {
  /*
   * object-fit polyfill
   */
  objectFitImages(); // https://www.npmjs.com/package/object-fit-images
  objectFitVideos(); // https://www.npmjs.com/package/object-fit-videos

  initHeaderNav({
    menuContainer: '.menu__section_categories',
    menuWrapper: '.header__menu-wrapper',
    transitionDuration: 450, // $_menu-duration in scss file.
  });

  const gridsWithFilters = getElementsArray('[data-type="grid-with-filters"]');
  gridsWithFilters.forEach(el => initGridWithFilters({ el }));

  $('.current-year').text((new Date()).getFullYear());

  $('.button').each((i, el) => $(el).html(`<span>${$(el).text()}</span>`));

  initCover({
    slider: '[data-type="cover-slider"]',
    slideSelector: '[data-type="cover-slider-slide"]',
    navNextSelector: '[data-type="cover-button-next"]',
    navPrevSelector: '[data-type="cover-button-prev"]',
    paginationSelector: '[data-type="pagination"]',
  });
  initSliders();
  initInput();
});



// WEBPACK FOOTER //
// ./scripts/common.js